import { createContext, useContext } from 'react';

// Échanges entre le menu général (AppHeader) et la page affichée :
// - setCrumb : complète le fil d'Ariane (« Tableau de bord › Maison Dupont ») ;
// - setLeaveGuard : une page avec des modifications non enregistrées intercepte la navigation du menu.
//   Le garde reçoit `proceed` et l'appelle (ou non) quand l'utilisateur a choisi.
export const AppShellContext = createContext({
  setCrumb: () => {},
  setLeaveGuard: () => {},
});

export function useAppShell() {
  return useContext(AppShellContext);
}
